import { render, staticRenderFns } from "./SimCard.vue?vue&type=template&id=2f5df78b&"
import script from "./SimCard.vue?vue&type=script&lang=js&"
export * from "./SimCard.vue?vue&type=script&lang=js&"
import style0 from "./SimCard.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports